// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2VCux","footer":"ModalFilter_footer__38-oz"};